import { Component, inject, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { LoginService } from '../../login/login.service';
import { SocketService } from '../socket.service';

@Component({
  selector: 'app-self-intro',
  templateUrl: './self-intro.component.html',
  styleUrls: ['./self-intro.component.scss'],
})
export class SelfIntroComponent implements OnInit {
  translatorLanguage: any;
  introData: {} = inject(MAT_DIALOG_DATA);
  constructor(
    private readonly translate: TranslateService,
    public dialogRef: MatDialogRef<SelfIntroComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly router: Router,
    private readonly loginService: LoginService,
    public readonly socket: SocketService,
  ) {
    this.translatorLanguage = localStorage.getItem('Language');
    this.translate.setDefaultLang('en');
    this.translate.use(this.translatorLanguage ?? 'en');
  }
  ngOnInit() {
    //
  }
  onCancel() {
    this.dialogRef.close();
  }
  onSubmit(expiry) {
    this.dialogRef.close();
    if (!expiry) {
      this.router.navigate([environment.dashboardPrefix + '/settings']);
    } else {
      this.router.navigate([environment.dashboardPrefix + '/settings'], {
        state: { action: 'payment' },
      });
    }
  }
  logoutAccount() {
    this.loginService.logout().subscribe((response) => {
      this.dialogRef.close();
      localStorage.clear();
      this.socket.disconnect();
      this.router.navigate([environment.dashboardPrefix + '/login']);
    });
  }
}
